<template>
  <v-container fluid grid-list-xl pt-0>
    <v-layout wrap>
      <v-flex xs12>
        <material-card
          :title="'月 Performance 生產概況篩選 (' + summaryMonth + ')'"
          class="card-shrink card-padding v-card__first"
          color="general"
        >
          <div class="card-memo-1 text-white">
            <v-icon class="text-warning">mdi-checkbox-blank</v-icon>
            黃字代表不良率大於1%
          </div>
          <div class="card-memo-2 text-white">
            <v-icon class="text-danger">mdi-checkbox-blank</v-icon>
            紅字代表不良率大於3%
          </div>
          <v-form>
            <v-container py-0 class="mw-100">
              <v-layout wrap>
                <v-flex xs12 lg2>
                  <v-menu
                    v-model="summaryMonthMenu"
                    :close-on-content-click="false"
                    lazy
                    transition="scale-transition"
                    max-width="290px"
                    offset-y
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                      v-model="summaryMonth"
                      label="時間"
                      prepend-icon="event"
                    />
                    <v-date-picker
                      v-model="summaryMonth"
                      :color="theme==='dark'?'danger':'general'"
                      type="month"
                      no-title
                      scrollable
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 lg2>
                  <v-autocomplete
                    v-model="summaryVendor"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryVendorMenu"
                    label="供應商（選填）"
                    clearable
                    outlined
                  />
                </v-flex>
                <v-flex xs12 sm6 lg2>
                  <v-autocomplete
                    v-model="summaryProcessType"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryProcessTypeMenu"
                    label="製程別"
                    :rules="[v => !!v || '請選擇製程別']"
                    outlined
                  />
                </v-flex>
                <v-flex xs12 sm6 lg3>
                  <v-autocomplete
                    v-model="summaryAsusDeviceIsn"
                    :class="{'danger-input' : theme==='dark' , 'general-input' : theme==='light'}"
                    :items="summaryAsusDeviceIsnMenu"
                    label="料號（選填）"
                    clearable
                    outlined
                  />
                </v-flex>
                <v-flex xs12 lg3 text-xs-right>
                  <v-btn class="mx-0 font-weight-light" color="general" @click="doSubmit()">
                    <v-icon class="mr-2">mdi-backup-restore</v-icon>查詢
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>

        <material-card>
          <div class="calendar">
            <div>
              <div style="margin-left: 70px;">
                <div v-for="(week, w) in WeekList" :key="'w'+w" class="calendar-week">
                  <span>{{ week }}</span>
                </div>
              </div>
              <div
                v-for="(list, d) in summaryMonthWeeksList"
                :key="'d'+d"
                class="calendar-row mr-0 ml-0"
              >
                <div class="calendar-weeks">
                  <span>W {{ list.weeks }}</span>
                  <router-link
                    :to="'/ctqThermalPerformance/weeklyProdutionSummary/' + weekParam(list)"
                    target="_blank"
                  >
                    <v-btn title="檢示每週生產概要" class="black text-light pl-2 pr-2">
                      <v-icon>mdi-clipboard-text-outline</v-icon>
                    </v-btn>
                  </router-link>
                </div>
                <div
                  v-for="(days, dd) in list.date"
                  :key="'dd'+dd"
                  :class="{'calendar-around': days.around}"
                  class="calendar-day calendar-day-fail"
                >
                  <a style="cursor: default;">{{ days.day }}</a>
                  <div
                    v-for="(fail, f) in days.failList"
                    :key="'f'+f"
                    class="calendar-fail-group"
                  >
                    <router-link
                      :to="statLink(fail, days.date)"
                      :style="'color:' + (fail.warningColor !== '' ? fail.warningColor : theme === 'dark' ? 'rgba(245,245,245,1)' : 'rgba(30,30,30,1)') + '!important;'"
                      target="_blank"
                      small
                    >
                      <div>{{ (fail.failRate*100).toFixed(1) }}% {{ fail.modelName }}</div>
                      <div class="calendar-fail-bottom">{{ fail.deviceIsn }} · {{ fail.processType }}</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </material-card>
      </v-flex>

      <v-flex flex_width_auto xs12>
        <material-card :title="'符合 '+summaryMonth+' 的總合數據'" color="deep-orange">
          <v-data-table
            :headers="headers"
            :items="responseFailTable"
            :pagination.sync="pagination"
            class="mt-3 elevation-1"
            multi-sort
            hide-actions
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span class="subheading font-weight-light text-general text--darken-3" v-text="header.text"/>
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.deviceIsn }}</td>
              <td>{{ item.processType }}</td>
              <td class="text-xs-right">{{ item.productionQty }}</td>
              <td class="text-xs-right">{{ item.failQty }}</td>
              <td class="text-xs-right">
                <v-chip :class="item.warningColor" small>{{ (item.failRate*100).toFixed(1) }}%</v-chip>
              </td>
              <td>{{ item.vendor }}</td>
              <td>
                <router-link
                  :to="statLink(item, DataStatistcStart, DataStatistcEnd)"
                  target="_blank"
                >
                  <v-btn class="mx-0 mr-3 font-weight-light small" color="primary">
                    <v-icon class="mr-2">mdi-chart-bar</v-icon>統計
                  </v-btn>
                </router-link>
              </td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { getMonthSummary } from './mockData'
import searchCascadeMixin from './searchCascadeMixin'

export default {
  name: 'CTQThermalPerformanceMonthly',
  mixins: [searchCascadeMixin],
  data () {
    return {
      summaryMonthMenu: false,
      summaryMonth: '2026-08',
      summaryMonthWeeksList: [],
      responseFailTable: [],
      DataStatistcStart: '',
      DataStatistcEnd: '',
      WeekList: ['日', '一', '二', '三', '四', '五', '六'],
      pagination: { rowsPerPage: -1, sortBy: 'failRate', descending: true },
      headers: [
        { sortable: true, text: '料號', value: 'deviceIsn' },
        { sortable: true, text: '製程別', value: 'processType' },
        { sortable: true, text: '生產數量', value: 'productionQty', align: 'right' },
        { sortable: true, text: '總不良數量', value: 'failQty', align: 'right' },
        { sortable: true, text: '總不良率', value: 'failRate', align: 'right' },
        { sortable: true, text: '供應商', value: 'vendor' },
        { sortable: false, text: '熱測數據', value: '' }
      ]
    }
  },
  computed: {
    ...mapState('app', ['theme', 'shrink'])
  },
  watch: {
    summaryMonth (val) {
      this.summaryMonthMenu = false
    }
  },
  mounted () {
    if (this.$route.params.searchDate) {
      this.summaryMonth = this.$route.params.searchDate
    }
    this.doSubmit()
  },
  methods: {
    weekParam (list) {
      const y = String(this.summaryMonth).substr(0, 4)
      const w = list.weeks < 10 ? ('0' + list.weeks) : String(list.weeks)
      return y + w
    },
    statLink (item, date, daterange) {
      let url = '/ctqThermalPerformance/testDataStatistc?deviceIsn=' + item.deviceIsn +
        '&modelname=' + item.modelName +
        '&date=' + date +
        '&vendorpk=' + item.vendorPk +
        '&vendor=' + item.vendor +
        '&processType=' + (item.processType || this.summaryProcessType)
      if (daterange) url += '&daterange=' + daterange
      return url
    },
    buildCalendar (byDate) {
      const year = Number(String(this.summaryMonth).substr(0, 4))
      const month = Number(String(this.summaryMonth).substr(5, 2)) - 1
      const first = new Date(year, month, 1)
      const last = new Date(year, month + 1, 0)
      this.DataStatistcStart = this.$moment(first).format('YYYY-MM-DD')
      this.DataStatistcEnd = this.$moment(last).format('YYYY-MM-DD')

      // start from Sunday of first week
      const start = new Date(first)
      start.setDate(first.getDate() - first.getDay())
      const weeks = []
      let cursor = new Date(start)
      while (cursor <= last || cursor.getDay() !== 0 || weeks.length === 0) {
        const weekNo = this.$moment(cursor).isoWeek()
        const days = []
        for (let i = 0; i < 7; i++) {
          const d = new Date(cursor)
          d.setDate(cursor.getDate() + i)
          const dateStr = this.$moment(d).format('YYYY-MM-DD')
          const around = d.getMonth() !== month
          days.push({
            day: d.getDate(),
            date: dateStr,
            around,
            failList: around ? [] : (byDate[dateStr] || [])
          })
        }
        weeks.push({ weeks: weekNo, date: days })
        cursor = new Date(cursor)
        cursor.setDate(cursor.getDate() + 7)
        if (cursor.getMonth() > month && cursor.getFullYear() >= year && cursor.getDay() === 0) break
        if (weeks.length > 6) break
      }
      this.summaryMonthWeeksList = weeks
    },
    doSubmit () {
      if (!this.summaryProcessType) return
      const { byDate, table } = getMonthSummary({
        month: this.summaryMonth,
        vendor: this.summaryVendor,
        deviceIsn: this.summaryAsusDeviceIsn,
        processType: this.summaryProcessType
      })
      this.buildCalendar(byDate)
      this.responseFailTable = table
    }
  }
}
</script>
